import { combineReducers } from 'redux';
import user from './user_reducer';

//�������� reducer�� ����ִ� ���
const rootReducer = combineReducers({
    user
});

export default rootReducer;